import { API } from '@/shared/plugins/Api/API'

class Quota extends API {
  constructor (options) {
    super('DPE')
  }
}

class Quotas extends API {
  list () {
    return this.request({
      method: 'get',
      url: 'v3/configurations/quotas'
    })
      .then(quotas => {
        return quotas
      })
  }
}

export default Quotas

export {
  Quotas,
  Quota
}
